import { FormInputType } from '@graphql/__generated/graphql'
import { isNaN } from 'lodash'
import moment from 'moment'
import React, { useEffect } from 'react'
import { CheckboxInput } from '../CheckboxInput'
import { CountInput } from '../CountInput'
import { DateTimeInput } from '../DateTimeInput'
import { DropdownInput } from '../DropdownInput'
import { TextInput } from '../TextInput'
import { ToggleInput } from '../ToggleInput'
import { InputPickerProps } from './InputPicker.type'

export const InputPicker = (props: InputPickerProps) => {
  const {
    ukey,
    type,
    label,
    placeholder,
    value = '',
    onChange,
    className,
    validations,
    required,
    show = true,
    testid,
    error,
    outputFormat = 'unset',
  } = props

  useEffect(() => {
    if (error) console.log(`InputPicker<${type}> Error: ${error}`)
  }, [error])

  if (!show) return <></>

  const onChangeFormatted = (e: any) => {
    let payload = e
    if (outputFormat === 'string') payload = `${e}`
    onChange && onChange(payload)
  }

  if (type === FormInputType.Number) {
    return (
      <TextInput
        show={show}
        key={ukey}
        required={required}
        validations={validations}
        value={value}
        onChange={onChangeFormatted}
        label={label}
        placeholder={placeholder}
        className={className}
        testid={testid}
        error={error}
        type="number"
      />
    )
    // return (
    //   <CountInput
    //     show={show}
    //     key={ukey}
    //     required={required}
    //     validations={validations}
    //     value={!!value ? (isNaN(parseInt(value)) ? 0 : parseInt(value)) : 0}
    //     onChange={(e) => {
    //       onChangeFormatted(`${e}`)
    //     }}
    //     label={label}
    //     placeholder={placeholder}
    //     minValue={props.min}
    //     maxValue={props.max}
    //     className={className}
    //     testid={testid}
    //     error={error}
    //   />
    // )
  }

  if (type === FormInputType.Dropdown) {
    return (
      <DropdownInput
        show={show}
        key={ukey}
        required={required}
        validations={validations}
        value={value}
        onChange={onChangeFormatted}
        label={label}
        placeholder={placeholder}
        options={props.options ?? []}
        className={className}
        testid={testid}
        error={error}
      />
    )
  }

  if (type === FormInputType.Date) {
    return (
      <DateTimeInput
        key={ukey}
        show={show}
        required={required}
        className={className}
        initialDate={props.initialDate}
        label={label}
        filterDate={props.filterDate}
        filterTime={props.filterTime}
        dateOnly={props.dateOnly}
        value={moment(value).toISOString()}
        onChange={onChangeFormatted}
        testid={testid}
        error={error}
      />
    )
  }

  if (type === FormInputType.Bool) {
    const BoolOptions = ['Yes', 'No']
    return (
      <ToggleInput
        key={ukey}
        show={show}
        required={required}
        selected={BoolOptions.findIndex(
          (o) => o.toLowerCase() === (value as string).toLowerCase()
        )}
        centerText
        options={BoolOptions}
        className={`w-full mt-4 ${className}`}
        value={value}
        callback={onChangeFormatted}
        label={label}
        testid={testid}
        error={error}
      />
    )
  }

  if (type === FormInputType.Checkbox) {
    return (
      <CheckboxInput
        isProtected
        key={ukey}
        show={show}
        required={required}
        className={`w-full mt-4 justify-start ${className}`}
        customStyles={`!justify-start`}
        value={
          value !== undefined && typeof value === 'boolean'
            ? value
            : (value as string).toLowerCase() === 'true'
        }
        onChange={onChangeFormatted}
        // label={label}
        border=""
        testid={testid}
        error={error}
      >
        <>{label}</>
      </CheckboxInput>
    )
  }

  return (
    <TextInput
      show={show}
      key={ukey}
      required={required}
      validations={validations}
      value={value}
      onChange={onChangeFormatted}
      label={label}
      placeholder={placeholder}
      className={className}
      testid={testid}
      error={error}
    />
  )
}
